// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingSpinner } from '../components/LoadingSpinner';
import RefinementHeader from '../components/RefinementHeader';
import SearchHeader from '../components/SearchHeader';
import WidgetList from '../components/widgets/WidgetList';
import { dispatchSkyfireMethods, dispatchTemplateRendered, globals } from '../utils';
import * as Styles from './View.scss';
const { window } = globals;
export default function Gallery(props) {
    var _a, _b;
    useStyles(Styles);
    const dispatch = useDispatch();
    const { widgets, header, id, searchHeader, refinementHeader, updatedAt, onEndOfWidgetsReached, isEnumerated } = props.template;
    const key = [id, updatedAt].join('-');
    useEffect(() => { var _a, _b, _c; return (_c = (_a = window) === null || _a === void 0 ? void 0 : (_b = _a).scrollTo) === null || _c === void 0 ? void 0 : _c.call(_b, 0, 0); }, []);
    const onEndOfList = useCallback(() => {
        dispatchSkyfireMethods(dispatch, props.template, onEndOfWidgetsReached);
    }, [dispatch, props.template, onEndOfWidgetsReached]);
    return (React.createElement("div", { className: Styles.viewContent },
        refinementHeader && React.createElement(RefinementHeader, { text: refinementHeader.text, refinementOptions: refinementHeader.refinementOptions, isActive: refinementHeader.isActive, isDisabled: refinementHeader.isDisabled, isOpened: refinementHeader.isOpened }),
        header && React.createElement("div", { className: Styles.header },
            React.createElement("h1", { className: 'music-headline-2' }, header)),
        searchHeader && (React.createElement(SearchHeader, Object.assign({}, searchHeader, { template: props.template }))),
        ((_a = widgets) === null || _a === void 0 ? void 0 : _a.length) ? (React.createElement("music-container", { id: id, key: key, onrendered: widgetsRendered },
            React.createElement(WidgetList, { list: widgets, handleSelected: handleSelected, onEndOfList: ((_b = onEndOfWidgetsReached) === null || _b === void 0 ? void 0 : _b.length) > 0 ? onEndOfList : undefined, isEnumerated: isEnumerated }))) :
            React.createElement(LoadingSpinner, null)));
    function handleSelected(onItemSelected) {
        dispatchSkyfireMethods(dispatch, props.template, onItemSelected);
    }
    ;
    function widgetsRendered(event) {
        if (event.target.id === props.template.id) {
            dispatchTemplateRendered(dispatch, props.template, event.detail);
            dispatchSkyfireMethods(dispatch, props.template, props.template.onViewed);
        }
    }
    ;
}
;
